import { I18nText } from '../i18n_text';
import { NameI18nData } from './names';
import { makeDefaultApi, request } from './request';
import { TrialTraitData } from './trials';

export interface ScheduledVisitData {
  id: string | null;
  name_json: I18nText;
  code: string;
  template_id?: number | null; // writable only when id is null; library scheduled visit id
  base_date_id?: string; // read-only
  // manual trials use base_date_idx, library trials use base_date_library_measurement_meta_id
  base_date_idx?: number; // write-only (wizard)
  base_date_library_measurement_meta_id?: number | null;
  manual?: boolean;
  base_date?: NameI18nData; // library
  days_offset: string | number;
  days_after_planting: string | number;
  order: number;
  n_min_visits: string | number;
  n_max_visits: string | number;
  repetition_number_of_days: string | number;
  maximum_number_of_repetitions: string | number;
  mobile_date_popup_enabled: boolean;
  traits: NameI18nData[];
  // trial-wizard only
  observations?: ScheduledVisitObservationData[];
  disabled: boolean;
}

export interface ScheduledVisitObservationData {
  id: string | null;
  measurement_meta_id?: string; // read-only
  // manual trials use measurement_meta_idx, library trials use library_measurement_meta_id
  measurement_meta_idx: number | null; // write-only (manual trials)
  library_measurement_meta_id?: number | null;
  order: number;
}

export interface ListParams {
  /** The React table's filter model, serialised, and its sort keys. */
  filter?: string;
  sort?: string[];
}

// only for library
export const { list, retrieve, save, remove } = makeDefaultApi<ScheduledVisitData, ListParams>(
  'scheduled_visits'
);

export interface ScheduledVisitTraitData {
  mm_id: string;
  mm_library_template_id: number;
  name: I18nText;
  order: number;
  ds_id: string;
  ds_name: I18nText;
}

export interface ScheduledVisitPreviewData {
  id: string;
  template_id: number | null;
  name_json: I18nText;
  code: string;
  n_min_visits: number;
  n_max_visits: number;
  base_date_observation: I18nText;
  observations: ScheduledVisitTraitData[];
  is_new: boolean;
  disabled?: boolean;
  days_offset?: number;
  days_after_planting?: number;
  repetition_number_of_days: number;
  maximum_number_of_repetitions: number;
  mobile_date_popup_enabled: boolean;
}

export function listTrialScheduledVisitsPreviews(
  trialId: string,
  traits: TrialTraitData[]
): Promise<ScheduledVisitPreviewData[]> {
  return request('POST', '/api/scheduled_visits/list_trial_scheduled_visits_preview/', {
    trial_id: trialId,
    traits,
  });
}

export interface ScheduledVisitTemplateDate {
  library_scheduled_visit_id: number;
  trait_reference_id: number;
  days_offset: number | null;
  days_after_planting: number | null;
}

export function listTrialScheduledVisitsTemplateDates(
  trialId: number | null,
  // either trial sv ids matching trialId or library sv ids
  scheduledVisitIds: number[]
): Promise<ScheduledVisitTemplateDate[]> {
  return request('POST', '/api/scheduled_visits/list_trial_scheduled_visits_template_dates/', {
    trial_id: trialId,
    scheduled_visit_ids: scheduledVisitIds,
  });
}
